import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'

import API from '../../../helper/API';
import DialogContent from './dialogContent';
import { getMobileOperatingSystem } from '../../../helper/mobile';

const styles = {
  textAlign: 'center',
  color: 'rgba(178, 178, 188, 1)',
  padding: '8px 0px'
}
export default function Unsubscribe({subscriptionId, isAutoPayCancelled, isCancelSubscription}) {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggle = () => setShow(!show);
  const device = getMobileOperatingSystem();
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [show]);

  const handleUnsubscribe = (value) => {
    console.log(value);
    if(subscriptionId) {
      setLoading(true);
        API.post(`/cancel/subscription?subscriptionId=${subscriptionId}`, {feedback: value})
        .then((res) => {
          toggle();
          window.location.reload();
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          setLoading(false);
        })  
    }
  }

  const isIOS = device === "ios";

  if(subscriptionId && !isAutoPayCancelled && !isIOS && isCancelSubscription) {
    return <div>
      <div style={styles} onClick={toggle}>Cancel Subscription</div>
      <Drawer open={show}
                duration={200}
                size={400}
                onClose={toggle}
                direction='bottom'
                className='drawer'>
            <DialogContent onSubmit={handleUnsubscribe} loading={loading} onClose={() => setShow(false)} />
      </Drawer>
    </div>
  }

  return null
}
